export const getIdArray = (array) =>
    array?.map((item) => (typeof item === 'object' ? item.id : item)) || [];
